import { queryOptions } from '@tanstack/react-query';

import { getCampaignsMetrics } from '@/api-clients/get-campaigns-metrics';
import { useTableContext } from '@/contexts/table-context';
import { useLocalDateRanges } from '@/hooks/use-local-date-ranges';
import { queryKeys } from '@/query-keys';

/**
 * The campaigns metrics query for the current search, filters and date range.
 * The metrics cards suspend on it; the campaigns table reads the same cache
 * entry for the page view, so both share one request.
 */
export function useCampaignsMetricsQueryOptions() {
  const {
    searchQuery,
    filters: { channelIds, statuses, positionIds, locationIds, brandIds },
    dateRange,
  } = useTableContext();
  const localDays = useLocalDateRanges();

  return queryOptions({
    queryKey: [
      ...queryKeys.campaignsMetrics,
      searchQuery,
      channelIds,
      statuses,
      positionIds,
      locationIds,
      brandIds,
      dateRange,
    ],
    queryFn: () =>
      getCampaignsMetrics({
        search: searchQuery,
        channelIds,
        statuses,
        positionIds,
        locationIds,
        brandIds,
        dateRange,
        localDays,
      }),
  });
}
